import * as React from 'react'
import styled from 'styled-components'

import { ApplyS, Indeterminate } from '../../icons'

const Container = styled.div`
  cursor: pointer;
  background-color: ${p => p.checked ? p.theme.color.turquoise : p.theme.color.background};
  border: 2px solid ${p => p.checked ? 'none' : p.theme.color.disabled};
  box-sizing: border-box;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 20px;
  width: 20px;
  transition: all 0.175s cubic-bezier(0.25, 0.1, 0.25, 1);
  pointer-events: ${p => (p.disabled ? 'none' : 'auto')};

  :hover {
    background: ${p => p.checked ? p.theme.color.turquoise : p.theme.color.backgroundRush
  } 0% 0% no-repeat padding-box;

    svg {
    fill: ${p => p.checked ? 'white' : p.theme.color.disabled};
    }
  }

  svg {
    fill: ${p => p.checked ? 'white' : p.theme.color.background};
    width: 10px;
  }
`

export const CheckboxButton = (props) => {
  const { checked, indeterminate, onClick, Icon, disabled } = props
  return (
    <Container
      onClick={onClick}
      checked={checked || indeterminate}
      disabled={disabled}
    >
      {Icon
        ? <Icon />
        : indeterminate && !checked
          ? <Indeterminate />
          : <ApplyS />}
    </Container>
  )
}
